export default "__VITE_PUBLIC_ASSET__f3104e36__"